import { getMe } from './me'
// Messages has one layout, New (Liam, 9 Oct 2026: "on both the owed and messages tab the toggle for the original or old
// version can be taken off as i'm happy with the new version now"). A choice of Original a phone or browser remembered
// is forgotten; the Original screen's code is left in rebook.ts, unreachable.
type Layout = 'new' | 'original'
function key(): string { const m=getMe();return `roundly:messages-layout:${m?.businessId}:${m?.email}:${m?.role}` }
export function messagesLayout(): Layout {
  try { if (localStorage.getItem(key()) !== null) localStorage.removeItem(key()) } catch { /* Nothing kept to forget. */ }
  return 'new'
}
